<template>
  <!-- <nav>
    <a @click="$router.push('/')"
      ><img
        src="https://amerykacars.pl/wp-content/uploads/logo-min.png"
        alt="logo"
        class="logo"
        width="200px"
    /></a>
  </nav> -->
  <router-view />
</template>

<script>
export default {
  name: "App",
  watch: {
    // The chrome-less routes get a marker on <body> so the app's global
    // styles (which would otherwise break the site layout) apply only there.
    $route: {
      immediate: true,
      handler(route) {
        const standalone = !route.matched.some(
          (r) => r.components && r.components.default
            && r.components.default.name === "SiteLayout"
        );
        document.body.classList.toggle("app-standalone", standalone);
      },
    },
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* The mirrored site needs a scrollable, non-clipping root: `overflow: hidden`
   here breaks the theme's sticky header and its footer-on-bottom layout. Keep
   it only for the chrome-less routes that japoniacars.pl embedded. */
body.app-standalone #app {
  overflow: hidden;
  font-family: "bicyclette", Helvetica, Arial, sans-serif;
}
::-webkit-scrollbar {
  width: 8px; /* width of the vertical scrollbar */
}

::-webkit-scrollbar-thumb {
  background-color: #888; /* color of the scrollbar */
  border-radius: 10px; /* round corners */
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

body {
  margin: 0;
  padding: 0;
  font: "bicyclette";
}

.center {
  width: 100%;
  height: 100%;
  display: block;
  background-color: white;
  margin-bottom: 20px;
  padding: 10px 0px;
}

@import url("https://p.typekit.net/p.css?s=1&k=hcu3gbq&ht=tk&f=35205.35206.35208&a=221371844&app=typekit&e=css");

@font-face {
  font-family: "bicyclette";
  src: url("https://use.typekit.net/af/39f12b/00000000000000007735acd8/30/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n3&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/39f12b/00000000000000007735acd8/30/d?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n3&v=3")
      format("woff"),
    url("https://use.typekit.net/af/39f12b/00000000000000007735acd8/30/a?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n3&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 300;
  font-stretch: normal;
}

@font-face {
  font-family: "bicyclette";
  src: url("https://use.typekit.net/af/87f362/00000000000000007735acdc/30/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n4&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/87f362/00000000000000007735acdc/30/d?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n4&v=3")
      format("woff"),
    url("https://use.typekit.net/af/87f362/00000000000000007735acdc/30/a?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n4&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 400;
  font-stretch: normal;
}

@font-face {
  font-family: "bicyclette";
  src: url("https://use.typekit.net/af/e8d041/00000000000000007735ace5/30/l?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n7&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/e8d041/00000000000000007735ace5/30/d?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n7&v=3")
      format("woff"),
    url("https://use.typekit.net/af/e8d041/00000000000000007735ace5/30/a?primer=f592e0a4b9356877842506ce344308576437e4f677d7c9b78ca2162e6cad991a&fvd=n7&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 700;
  font-stretch: normal;
}

@media only screen and (min-width: 600px) {
  .center {
    /* width: 70%; */
    height: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    background-color: white;
    margin-bottom: 20px;
    padding: 30px;
  }
}
/* Scoped to the standalone routes — the mirrored site has its own <nav>s. */
body.app-standalone nav {
  margin: auto;
}
  </style>

<style scoped>
nav {
  padding: 30px;
}

nav a {
  margin: auto;
  display: block;
  width: 200px;
}
h3 {
  text-align: center;
}
/* s */
</style>
